import React, { useState, useCallback, useEffect, useRef } from 'react';
import { toast } from 'react-hot-toast';
import { Form } from '@unform/web';
import { MdDelete } from 'react-icons/md';
import { useInView } from 'react-intersection-observer';
import { v4 } from 'uuid';

import { IoCloseSharp } from 'react-icons/io5';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  TabContent,
  TabPane,
} from 'reactstrap';
import * as Yup from 'yup';
import { format, set } from 'date-fns';
import {
  FaExclamationTriangle,
  FaPlus,
  FaQuestionCircle,
  FaSearch,
} from 'react-icons/fa';
import ReactInputMask from 'react-input-mask';
import Input from '~/components/Form/Input';
import Select from '~/components/Form/SelectInput';
import api from '~/services/api';
import InputRow from '~/components/Rows/InputRow';
import IntermediaryRow from '~/components/Rows/IntermediaryRow';

import TextareaContainer from '~/components/Form/Textarea';
import getValidationErrors from '~/services/getValidationErrors';
import CheckboxInput from '~/components/Form/Checkbox';

import InputLossReport from '~/components/Inputs/InputLossReport';
import { useAuth } from '~/context/AuthContext';
import formatCompleteDate from '~/services/formatCompleteDate';
import PermissionErrorContainer from '~/components/PermissionErrorContainer';
import { generateInputsReportSheetXLSX } from '~/services/generateInputsReportSheet';
import FileSaver from 'file-saver';
import {
  DownloadButton,
  Tabs,
  Button as BtnUiKit,
  InformationDiv,
  IconInput,
} from 'ui-kit-takeat';
import {
  IconPlus,
  IconRefresh,
  Button as NewUiKitButton,
  Select as NewSelect,
  Input as NewInput,
  IconClose,
  NotificationBanner,
  Radio,
  IconTrashFilled,
  Checkbox,
  SingleCalendar,
  Divider,
  IconMinus,
  formatPrice,
  HighlightIcon,
  IconWarningFilled,
  IconSearch,
} from 'takeat-design-system-ui-kit';
import { generateIntermediariesReportSheetXLSX } from '~/services/generateIntermediariesReportSheet';
import { PageTitle } from '~/components/PageTitle';
import InputInventoryReport from '~/components/Inputs/InputInventoryReport';
import InputNfeReport from '~/components/Inputs/InputNfeReport';
import InputSmartQuote from '~/components/Inputs/InputSmartQuote';
import GetDemoButton from '~/components/Buttons/GetDemoButton';
import {
  Container,
  Header,
  ComplementsTable,
  ErrorContainer,
  Delete,
  SearchDiv,
  InputsTable,
  InventaryButton,
  StyledTable,
  InputInfoArea,
  InputLine,
  TableArea,
  TableStyled,
  ModalStyled,
  InfoDiv,
  FooterModal,
  StyledModal,
  ContainerToUpdate,
  BodyToUpdate,
  TextHeader,
  ContainerText,
  Overlay,
} from './styles';

function Inputs() {
  const { user, getProfileData } = useAuth();
  const [inputs, setInputs] = useState([]);
  const [visibleInputs, setVisibleInputs] = useState([]);
  const [itemsToShow, setItemsToShow] = useState(20);
  const { ref, inView } = useInView();
  const [intermediary, setIntermediary] = useState([]);
  const [inputsFiltered, setInputsFiltered] = useState([]);
  const [intermediaryFiltered, setIntermediaryFiltered] = useState([]);
  const [permission, setPermission] = useState();
  const [loadingPage, setLoadingPage] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [unidadeSelected, setUnidadeSelected] = useState('Kg');
  const [nameIntermediary, setNameIntermediary] = useState('');
  const [yeldIntermediary, setYeldIntermediary] = useState(1);
  const [filterString, setFilterString] = useState('');
  const [filterStringInter, setFilterStringInter] = useState('');
  const [isInventory, setIsInventory] = useState(false);
  const [inventory, setInventory] = useState({});
  const [isInterInventory, setIsInterInventory] = useState(false);
  const [interInventory, setInterInventory] = useState({});
  const [createCashFlowOnNewInput, setCreateCashFlowOnNewInput] =
    useState(true);
  const [filterInputMaster, setFilterInputMaster] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState();

  function handleCreateCashFlowOnNewInput() {
    setCreateCashFlowOnNewInput(!createCashFlowOnNewInput);
  }

  const [categories, setCategories] = useState();
  const [cashFlowCategoryInputs, setCashFlowCategoryInputs] = useState({
    value: '',
    label: 'Categoria',
  });

  const formIntermediaryRef = useRef(null);
  const formRef = useRef(null);
  const formRefBank = useRef(null);
  const formRefSupplier = useRef(null);

  const validateUser = useCallback(async () => {
    setLoadingPage(true);
    try {
      const response = await api.get(
        `/restaurants/users/role-permission/${'MenuInventory'}`
      );
      setLoadingPage(false);
      const { can_read } = response.data.MenuInventory;

      setPermission(can_read);
    } catch (error) {
      // setPermission(false);
      // if (error?.response?.data?.payload?.user_access === 'pdv') {
      //   window.location.href = '/operation';
      // }
      setLoadingPage(false);
      toast.error('Erro ao solicitar acesso');
    }
  }, []);

  const getInputs = useCallback(async () => {
    try {
      const response = await api.get('/restaurants/inputs');
      setInputs(response.data);
      setVisibleInputs(response.data.slice(0, itemsToShow));
      setInputsFiltered([]);
      setInputsFiltered(response.data);

      return response;
    } catch (err) {
      toast.error('Falha ao carregar dados');
    }
  }, []);

  const getIntermediary = useCallback(async () => {
    try {
      const response = await api.get('/restaurants/intermediary');
      setIntermediary(response.data);
    } catch (err) {
      toast.error('Falha ao carregar dados intermediarios');
    }
  }, []);

  const getCategoriesDetails = useCallback(async () => {
    try {
      const response = await api.get(
        '/restaurants/cash-flows/categories-detail'
      );

      const categoriesSelect = response?.data?.map((category) => {
        return {
          value: category.id,
          label: category.text,
        };
      });

      setCategories(categoriesSelect);
    } catch (error) {
      toast.error('Erro ao baixar métodos de pagamento');
    }
  }, []);

  const [suppliers, setSuppliers] = useState();
  const [banks, setBanks] = useState();

  const getSuppliers = useCallback(async () => {
    try {
      const response = await api.get('/restaurants/cash-flows/providers');

      const providersSelect = response?.data?.map((provider) => {
        return {
          value: provider.id,
          label: provider.name,
        };
      });

      setSuppliers(providersSelect);
    } catch (error) {
      toast.error('Erro ao baixar fornecedores');
    }
  }, []);

  const getBanks = useCallback(async () => {
    try {
      const response = await api.get('/restaurants/cash-flows/bank-accounts');

      const banksSelect = response?.data?.map((bank) => {
        return {
          value: bank.id,
          label: bank.name,
        };
      });

      setBanks(banksSelect);
    } catch (error) {
      toast.error('Erro ao baixar contas de banco');
    }
  }, []);

  const getPaymentMethods = useCallback(async () => {
    try {
      const response = await api.get('/restaurants/cash-flows/payment-methods');

      const methodsSelect = response?.data?.map((method) => {
        return {
          value: method.id,
          label: method.name,
        };
      });

      setPaymentMethods(methodsSelect);
    } catch (error) {
      toast.error('Erro ao baixar métodos de pagamento');
    }
  }, []);

  useEffect(() => {
    getBanks();
  }, [getBanks]);

  useEffect(() => {
    getSuppliers();
  }, [getSuppliers]);

  useEffect(() => {
    getPaymentMethods();
  }, [getPaymentMethods]);

  useEffect(() => {
    validateUser();
    getCategoriesDetails();
  }, [validateUser, getCategoriesDetails]);

  const [modal, setModal] = useState(false);
  const [modalErroNotAllowed, setModalErroNotAllowed] = useState(false);
  const [confirmModalClose, setConfirmModalClose] = useState(false);

  function toggleConfirmModalClose() {
    setConfirmModalClose(!confirmModalClose);
  }
  const toggle = () => {
    if (modal) {
      toggleConfirmModalClose();
    } else {
      setModal(!modal);
    }
  };

  const [modalIntermediary, setModalIntermediary] = useState(false);

  

   const toggleIntermediary = () => {
    if (user.allow_inputs) {
      setModalIntermediary(!modalIntermediary);
    } else {
      setModalErroNotAllowed(!modalErroNotAllowed);
    }
  };

  const handleDelete = useCallback(async (id) => {
    try {
      if (window.confirm('Tem certeza que deseja deletar este insumo?')) {
        const response = await api.delete(`/restaurants/inputs/${id}`);
        setInputs(response.data);

        toast.success('Insumo deletado com sucesso!');
      }
    } catch (error) {
      toast.error('Erro ao deletar insumo.');
    }
  }, []);

  const handleDeleteIntermediary = useCallback(
    async (id, filterStringInter) => {
      try {
        if (
          window.confirm(
            'Tem certeza que deseja deletar este produto intermediario?'
          )
        ) {
          const response = await api.delete(`/restaurants/intermediary/${id}`);
          setIntermediary(response.data);

          toast.success('Produto Intermediario deletado com sucesso!');
        }
      } catch (error) {
        toast.error('Erro ao deletar produto intermediario.');
      }
    },
    []
  );

  const [paidCheck, setPaidCheck] = useState(false);

  function handleSetPaidCheck() {
    setPaidCheck(!paidCheck);
  }

  const [isSubmittingInput, setIsSubmittingInput] = useState(false);


  const unidade_options = [
    {
      value: 'UN',
      label: 'UNIDADE',
    },
    {
      value: 'KG',
      label: 'QUILOGRAMA',
    },
    {
      value: 'L',
      label: 'LITRO',
    },
    {
      value: 'ML',
      label: 'MILILITRO',
    },
    {
      value: 'PC',
      label: 'PACOTE',
    },
    {
      value: 'BD',
      label: 'BALDE',
    },
    {
      value: 'CX',
      label: 'CAIXA',
    },
    {
      value: 'FD',
      label: 'FARDO',
    },
    {
      value: 'GF',
      label: 'GARRAFA',
    },
    {
      value: 'G',
      label: 'GRAMA',
    },
    {
      value: 'GL',
      label: 'GALAO',
    },
    {
      value: 'PT',
      label: 'POTE',
    },
  ];

  const [unidadeOptionsDefault, setUnidadeOptionsDefault] = useState(unidade_options[1]);

  const inputs_select = inputs
    .filter((inp) => !inp.is_master)
    .map((input) => ({
      value: input.id,
      label: `${input.name} (${input.unidade})`,
      unidade: input.unidade,
      unitary_price: input.unitary_price,
      quantidade: input.quantidade,
    }));

  const inter_select = intermediary.map((inter) => ({
    value: inter.id,
    label: inter.name,
    unidade: inter.unidade,
    unitary_price: inter.unitary_price,
    quantidade: inter.quantidade,
  }));

  const [interInputs, setInterInputs] = useState([]);
  const [defaultInterValue, setDefaultInterValue] = useState(0);
  const [selectInput, setSelectInput] = useState([]);
  const [quantInter, setQuantInter] = useState(0);

  const [interInter, setInterInter] = useState([]);
  const [defaultInterInterValue, setDefaultInterInterValue] = useState(0);
  const [selectInter, setSelectInter] = useState([]);

  function insertInputInter(selectInput, defaultInterValue) {
    const exists = interInputs.filter((int) => int.id === selectInput.value);

    if (exists.length > 0) {
      toast.error('Insumo já cadastrado');
    } else {
      setInterInputs([
        ...interInputs,
        {
          name: selectInput.label,
          id: selectInput.value,
          quantidade_inter_value: defaultInterValue.replace(',', '.'),
          unidade: selectInput.unidade,
          unitary_price: selectInput.unitary_price,
          quantidade: selectInput.quantidade,
        },
      ]);
    }
  }

  function deleteInputInter(id) {
    const updated = interInputs.filter((int) => int.id !== id);
    setInterInputs(updated);
  }

  function insertInterInter(selectInter, defaultInterValue) {
    const exists = interInter.filter((int) => int.id === selectInter.value);

    if (exists.length > 0) {
      toast.error('Produto Intermediário já cadastrado');
    } else {
      setInterInter([
        ...interInter,
        {
          name: selectInter.label,
          id: selectInter.value,
          quantidade_inter_value: defaultInterValue.replace(',', '.'),
          unidade: selectInter.unidade,
          unitary_price: selectInter.unitary_price,
          quantidade: selectInter.quantidade,
        },
      ]);
    }
  }

  function deleteInterInter(id) {
    const updated = interInter.filter((int) => int.id !== id);
    setInterInter(updated);
  }

  const [discountInputsOnHandleInter, setDiscountInputsOnHandleInter] =
    useState(true);

  const [isSubmittingIntermediary, setIsSubmittingIntermediary] =
    useState(false);

  async function handleIntermediary(data) {
    try {
      setIsSubmittingIntermediary(true);
      if (formIntermediaryRef.current) {
        formIntermediaryRef.current.setErrors({});
      }

      const schema = Yup.object().shape({
        name: Yup.string().required('Nome obrigatório'),
        unidade: Yup.string().required('Unidade Obrigatória'),
        quantidade_inter: Yup.string().required('Quantidade Obrigatória'),
        yield: Yup.string().required('Valor Obrigatório'),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      const inputs = interInputs.map((inter) => ({
        id: inter.id,
        quantidade: inter.quantidade_inter_value,
      }));
      const intermediaries = interInter.map((inter) => ({
        id: inter.id,
        quantidade: inter.quantidade_inter_value,
      }));

      const handleData = {
        name: data.name,
        quantidade: quantInter.toString().replace(',', '.'),
        unidade: data.unidade,
        recipe: data.recipe,
        yield: data.yield,
        minimum_stock: data.minimum_stock,
        ideal_stock: data.ideal_stock,
        inputs,
        intermediaries,
        discount_inputs: discountInputsOnHandleInter,
      };

      const response = await api.post(`/restaurants/intermediary`, handleData);
      setIntermediary(response.data);
      setInterInputs([]);
      setInterInter([]);
      getInputs(filterString);
      toggleIntermediary();
      setIsSubmittingIntermediary(false);
      toast.success('Produto intermediario adiconado com sucesso!');
    } catch (error) {
      setIsSubmittingIntermediary(false);
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        if (formIntermediaryRef.current) {
          formIntermediaryRef.current.setErrors(errors);
        }
      } else {
        toast.error('Erro ao adicionar produto intermediário.');
      }
    }
  }
  useEffect(() => {
    let filtered = inputsFiltered.length > 0 ? inputsFiltered : inputs;

    if (filterString !== '') {
      filtered = filtered.filter((inter) =>
        inter.name.toLowerCase().includes(filterString.toLowerCase())
      );
    } else {
      filtered = inputs;
    }

    if (filterInputMaster) {
      filtered = filtered.filter((filter) => filter.is_master);
    }

    if (cashFlowCategoryInputs.value) {
      const { value } = cashFlowCategoryInputs;

      filtered = filtered.filter(
        (input) => input.cash_flow_category_subcategory_id === value
      );
    }

    setInputsFiltered(filtered);
  }, [inputs, filterString, cashFlowCategoryInputs, filterInputMaster]);

  useEffect(() => {
    setVisibleInputs(inputsFiltered.slice(0, 20));
  }, [inputsFiltered]);

  useEffect(() => {
    if (inView && visibleInputs.length < inputsFiltered.length) {
      const moreItems = inputsFiltered.slice(
        visibleInputs.length,
        visibleInputs.length + 20
      );
      setVisibleInputs((prev) => [...prev, ...moreItems]);
    }
  }, [inView, inputsFiltered, visibleInputs]);

  function clearInputFilters() {
    setFilterString('');
    setCashFlowCategoryInputs({
      value: '',
      label: 'Categoria',
    });
  }

  const handleInventory = async () => {
    try {
      if (isInventory) {
        const response = await api.post(
          `/restaurants/inputs/inventory`,
          inventory
        );

        // setInputs(
        //   inputs.map((inp) => {
        //     const match = response.data.find((r) => r.id === inp.id);
        //     if (match) {
        //       return { ...inp, ...match };
        //     }
        //     return inp;
        //   })
        // );
      }

      setIsInventory(!isInventory);
      setInventory({});

      try {
        const response = await api.get('/restaurants/inputs');
        setInputs(response.data);
        setInputsFiltered([]);
        setInputsFiltered(response.data);
      } catch (err) {
        toast.error('Falha ao carregar dados');
      }
      // getInputs();
    } catch (err) {
      toast.error('Algo deu errado');
    }
  };

  const handleInterInventory = async () => {
    try {
      if (isInterInventory) {
        const response = await api.post(
          `/restaurants/intermediaries/inventory`,
          interInventory
        );

        setIntermediary(
          intermediary.map((inter) => {
            const match = response.data.find((r) => r.id === inter.id);
            if (match) {
              return { ...inter, ...match };
            }
            return inter;
          })
        );
      }
      setIsInterInventory(!isInterInventory);
      setInterInventory({});
    } catch (err) {
      toast.error('Algo deu errado');
    }
  };

  useEffect(
    function filterIntermediaries() {
      function normalize(str) {
        return str
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase();
      }

      let filtered = intermediary;

      if (filterStringInter !== '') {
        const normalizedFilter = normalize(filterStringInter);
        filtered = filtered.filter((inter) =>
          normalize(inter.name).includes(normalizedFilter)
        );
      }

      setIntermediaryFiltered(filtered);
    },
    [intermediary, filterStringInter]
  );

  useEffect(() => {
    if (filterInputMaster) {
      const newFiltered = inputs.filter((input) => input.is_master);
      setInputsFiltered(newFiltered);
    } else {
      setInputsFiltered(inputs);
    }
  }, [filterInputMaster]);

  // create banks

  const [isModalCreateBankOpen, setIsModalCreateBankOpen] = useState(false);

  const toggleModalCreateBank = useCallback(() => {
    setIsModalCreateBankOpen(!isModalCreateBankOpen);
  }, [isModalCreateBankOpen]);

  const handleBankSubmit = useCallback(
    async (data) => {
      try {
        if (formRefBank?.current) {
          formRefBank.current.setErrors({});
        }
        const schema = Yup.object().shape({
          name: Yup.string().required('Nome obrigatório'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        await api.post('/restaurants/cash-flows/bank-accounts', {
          name: data.name,
        });

        toast.success('Conta cadastrada com sucesso!');

        getBanks();
        toggleModalCreateBank();
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          if (formRefBank?.current) {
            formRefBank.current.setErrors(errors);
          }
        } else {
          // console.tron.log(error);
          toast.error(`Erro ao cadastrar conta!`);
        }
      }
    },
    [getBanks, toggleModalCreateBank]
  );

  // create suplliers

  const [isModalCreateSuppliersOpen, setIsModalCreatesuppliersOpen] =
    useState(false);

  const toggleModalCreateSuplliers = useCallback(() => {
    setIsModalCreatesuppliersOpen(!isModalCreateSuppliersOpen);
  }, [isModalCreateSuppliersOpen]);

  const handleSupplierSubmit = useCallback(
    async (data) => {
      try {
        if (formRefSupplier?.current) {
          formRefSupplier.current.setErrors({});
        }
        const schema = Yup.object().shape({
          name: Yup.string().required('Nome obrigatório'),
          cnpj: Yup.string()
            .required('CNPJ/ CPF obrigatório')
            .trim()
            .matches('^[0-9]+$', 'Apenas números, sem espaço'),
          phone: Yup.string().required('Telefone obrigatório'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        await api.post('/restaurants/cash-flows/providers', {
          name: data.name,
          phone: data.phone,
          cnpj: data.cnpj,
        });

        toast.success('Fornecedor cadastrada com sucesso!');

        getSuppliers();
        toggleModalCreateSuplliers();
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          if (formRefSupplier?.current) {
            formRefSupplier.current.setErrors(errors);
          }
        } else {
          toast.error(`Erro ao cadastrar fornecedor!`);
        }
      }
    },
    [getSuppliers, toggleModalCreateSuplliers]
  );

  const handleDownloadInputs = async () => {
    try {
      const sheet = await generateInputsReportSheetXLSX(inputs);

      const uint = new Uint8Array(sheet);
      const blob = new Blob([uint], { type: 'application/excel' });

      FileSaver.saveAs(
        blob,
        `Relatório Insumos (${format(new Date(), 'dd-MM-yyyy')}).xlsx`
      );
    } catch (err) {
      console.log('Error download sheet > ', err);
    }
  };

  const handleDownloadInters = async () => {
    try {
      const sheet = await generateIntermediariesReportSheetXLSX(
        intermediaryFiltered
      );

      const uint = new Uint8Array(sheet);
      const blob = new Blob([uint], { type: 'application/excel' });

      FileSaver.saveAs(
        blob,
        `Intermediários(${format(new Date(), 'dd-MM-yyyy')}).xlsx`
      );
    } catch (err) {
      console.log('Error download sheet > ', err);
    }
  };

  const CACHE_KEY = '@gddashboard:estoque';
  const CACHE_DURATION = 5 * 60 * 1000;
  const [carregando, setCarregando] = useState(true);

  const restaurantsNotUpdatedStock = [
    8094, 103263, 322, 312, 296, 321, 314, 79107,
  ];

  async function updateInputs5Minutes() {
    const cached = localStorage.getItem(CACHE_KEY);
    if (cached) {
      const { timestamp } = JSON.parse(cached);
      const expirado = Date.now() - timestamp > CACHE_DURATION;

      if (!expirado) {
        getInputs();
        getIntermediary();
        setCarregando(false);
        return;
      }
    }

    try {
      await api.post('/restaurants/inputs/update-restaurant');

      localStorage.setItem(
        CACHE_KEY,
        JSON.stringify({
          timestamp: Date.now(),
        })
      );

      getInputs();
      getIntermediary();
      getProfileData();
    } catch (e) {
      console.log('Falha ao carregar insumos', e);
    } finally {
      setCarregando(false);
    }
  }

  useEffect(() => {
    if (!restaurantsNotUpdatedStock.includes(user.id)) {
      updateInputs5Minutes();
    } else {
      getInputs();
      getIntermediary();
    }
  }, []);

  const updateInputs = useCallback(async () => {
    try {
      setCarregando(true);
      await api.post('/restaurants/inputs/update-restaurant');
      await getInputs();
      await getIntermediary();

      localStorage.setItem(
        CACHE_KEY,
        JSON.stringify({
          timestamp: Date.now(),
        })
      );
      await getProfileData();
      toast.success('Estoque atualizado!');
    } catch (error) {
      toast.error('Erro ao atualizar estoque. Tente novamente.');
    }
    setCarregando(false);
  }, []);


  const [createType, setCreateType] = useState('new');

  function handleChangeCreateType(type) {
    setCreateType(type);
  }

  const [inputsToAdd, setInputsToAdd] = useState([]);

  // states to edit inputs at modal add inputs
  const [inputQuant, setInputQuant] = useState(0);
  const [inputZero, setInputZero] = useState(0);
  const [inputInicial, setInputInicial] = useState(0);
  const [valueToSend, setValueToSend] = useState(0);
  const [totalToSend, setTotalToSend] = useState(0);
  const [isAverage, setIsAverage] = useState(false);

  const [inputToAdd, setInputToAdd] = useState({
    id: v4(),
    name: '',
    unidade: 'KG',
    quantidade: 0,
    total: 0,
    total_value: 0,
    minimum_stock: 0,
    ideal_stock: 0,
    cash_flow_category_subcategory: '',
    is_multistore_child: false,
  });

  function handleChangeAverage() {
    setIsAverage(!isAverage);
  }

  function handleChangeInputToAdd(key, e) {
    if (key === 'unidade') {
      setInputToAdd({ ...inputToAdd, [key]: e.value });
    } else if (key === 'cash_flow_category_subcategory') {
      setInputToAdd({
        ...inputToAdd,
        [key]: e,
        cash_flow_category_subcategory_id: e.value,
      });
    } else if (key === 'total') {
      setInputToAdd({ ...inputToAdd, [key]: Number(e.target.value) || 0 });
    } else {
      setInputToAdd({ ...inputToAdd, [key]: e.target.value });
    }
  }

  const handleAddNewInput = useCallback(() => {
    const exists = inputsToAdd.filter((inp) => inp.name === inputToAdd.name);

    const newQtdd = isNaN(Number(inputInicial) + Number(inputZero))
      ? Number(inputInicial).toFixed(4)
      : (Number(inputInicial) + Number(inputZero)).toFixed(4);

    const newInput = {
      ...inputToAdd,
      quantidade: Number(newQtdd) !== 0 ? newQtdd : inputToAdd.quantidade,
      total: totalToSend > 0 ? totalToSend : inputToAdd.total,
    };

    if (exists.length > 0) {
      toast.error('Insumo já adicionado');
    } else if (
      !inputToAdd.name ||
      !inputToAdd.unidade ||
      !inputToAdd.cash_flow_category_subcategory ||
      (createType === 'edit' &&
        (!inputToAdd.cash_flow_category_subcategory ||
          !inputToAdd.cash_flow_category_subcategory_id))
    ) {
      toast.error(
        'Os campos Nome do Insumo, Unidade e Associar centro de custo são obrigatórios.'
      );
    } else {
      setInputsToAdd([...inputsToAdd, newInput]);
      setValueToSend(0);
      setTotalToSend(0);
      setInputInicial(0);
      setInputZero(0);
      setInputToAdd({
        id: v4(),
        name: '',
        unidade: 'KG',
        quantidade: 0,
        total: 0,
        minimum_stock: 0,
        ideal_stock: 0,
        cash_flow_category_subcategory: '',
      });

      setUnidadeOptionsDefault(unidade_options[1])
    }
  }, [inputToAdd, totalToSend, inputsToAdd, inputInicial, inputZero]);

  const [inputToDelete, setInputToDelete] = useState(false);
  const [isModalDeleteInputOnpened, setIsModalDeleteInputOpened] =
    useState(false);

  function handleDeleteInputAtList(id) {
    setInputToDelete(id);
    setIsModalDeleteInputOpened(true);
  }

  function handleConfirmDelete(input) {
    const updated = inputsToAdd.filter((inp) => inp.id !== input);

    setInputsToAdd(updated);
    setIsModalDeleteInputOpened(false);
  }

  function toggleModalDeleteInput() {
    setIsModalDeleteInputOpened(!isModalDeleteInputOnpened);
  }

  function handleSelectInput(e) {
    const inputFind = inputs.find((item) => item.id === e.value);

    if (inputFind) {
      setInputQuant(inputFind.quantidade);
      setInputInicial(inputFind.quantidade);
      setValueToSend(inputFind.quantidade);
      setIsAverage(!(inputFind.quantidade <= 0));

      setInputToAdd({
        id: inputFind.id,
        name: inputFind.name,
        unidade: inputFind.unidade,
        quantidade: inputFind.quantidade,
        total: inputFind.total_to_send,
        total_value: inputFind.total_value,
        minimum_stock: inputFind.minimum_stock || 0,
        unitary_price: inputFind.unitary_price,
        ideal_stock: inputFind.ideal_stock || 0,
        cash_flow_category_subcategory_id:
          inputFind.cash_flow_category_subcategory_id,
        cash_flow_category_subcategory: {
          label: inputFind.category_subcategory,
          value: inputFind.cash_flow_category_subcategory_id,
          id: inputFind.cash_flow_category_subcategory_id,
        },
        is_multistore_child: inputFind.is_multistore_child,
      });
    }
  }

  const [paidDate, setPaidDate] = useState(new Date().toISOString());
  const [dueDate, setDueDate] = useState(new Date().toISOString());
  const [cashFlowPaymentMethodId, setCashFlowPaymentMethodId] = useState(false);
  const [bankId, setBankId] = useState(false);
  const [providerId, setProviderId] = useState(false);

  async function handleSubmitInputs() {
    const inputArraysFiltered = inputsToAdd.map(({ id, ...inp }) => {
      if (typeof id === 'number') {
        inp.id = id;
      }
      return {
        ...inp,
        minimum_stock: inp.minimum_stock.toString(),
        ideal_stock: inp.ideal_stock.toString(),
      };
    });
    try {
      if (createCashFlowOnNewInput && !cashFlowPaymentMethodId) {
        toast.error('Informar o método de pagamento.');

        return;
      }
      await api.post('/restaurants/many/inputs', {
        inputs: inputArraysFiltered,
        provider_id: providerId || null,
        bank_account_id: bankId || null,
        due_date: createCashFlowOnNewInput ? dueDate : null,
        paid: paidCheck,
        paid_at: paidCheck ? paidDate : null,
        create_cash_flow: createCashFlowOnNewInput,
        cash_flow_payment_method_id: cashFlowPaymentMethodId || null,
      });

      // if (inputsFiltered) {
      //   const newInputs = [...inputsFiltered];
      //   const inputFind = newInputs.findIndex((item) => item.id === input.id);

      //   if (inputFind !== -1) {
      //     newInputs[inputFind] = { ...response.data };

      //     setInputsFiltered(newInputs);
      //   }
      // }
      await getInputs();
      toast.success('Insumo(s) cadastrado(s) com sucesso!');
      setPaidCheck(false);
      setModal(false);
    } catch (error) {
      toast.error('Erro ao adicionar insumo(s).');
      console.log(error);
    }
  }

  const totalInputs = inputsToAdd
    .filter((item) => Number(item.total) > 0)
    .reduce((acc, input) => acc + Number(input.total), 0);

  return !permission ? (
    <PermissionErrorContainer loading={loadingPage} />
  ) : (
    <Container>
      <StyledModal
        isOpen={isModalDeleteInputOnpened}
        toggle={toggleModalDeleteInput}
        size="md"
      >
        <p
          style={{ padding: 20, color: '#222', fontSize: 16, fontWeight: 600 }}
        >
          Deseja realmente deletar este item?
        </p>
        <ModalFooter
          style={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <NewUiKitButton onClick={toggleModalDeleteInput}>
            Cancelar
          </NewUiKitButton>
          <NewUiKitButton
            customColor="#2EC9B7"
            onClick={() => {
              handleConfirmDelete(inputToDelete);
            }}
          >
            Confirmar
          </NewUiKitButton>
        </ModalFooter>
      </StyledModal>
      <Header>
        <div>
          <div style={{ display: 'flex' }}>
            <PageTitle>
              {activeTab === 0 ? 'Insumos' : 'Produtos intermediários'}
            </PageTitle>
            {activeTab === 1 ? (
              <GetDemoButton url="https://app.getdemo.com.br/d/4b0d7379-51b7-4609-bb8d-9566ce630c53" />
            ) : (
              <GetDemoButton url="https://app.getdemo.com.br/d/a127306a-0afb-46d2-a2fd-45e2d344a824" />
            )}
          </div>

          <span>Ficha técnica</span>
        </div>
      </Header>

      {!restaurantsNotUpdatedStock.includes(user.id) && carregando && (
        <Overlay>
          <ContainerToUpdate>
            <BodyToUpdate>
              <HighlightIcon
                size={28}
                icon={<IconWarningFilled />}
                color="yellow"
              />
              <ContainerText>
                <TextHeader $bold>Atualizando o estoque</TextHeader>
                <TextHeader>
                  Estamos sincronizando as informações. Isso leva só alguns
                  segundos. Não feche a página!
                </TextHeader>
              </ContainerText>
            </BodyToUpdate>
          </ContainerToUpdate>
        </Overlay>
      )}

      {user.use_stock && (
        <Row style={{ marginBottom: 15 }}>
          <Col style={{ display: 'flex' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <NewUiKitButton
                onClick={() => {
                  updateInputs();
                }}
                customColor="#FFB32F"
                style={{ borderRadius: 12 }}
                icon={<IconRefresh />}
                textStyle={{
                  fontFamily: 'Poppins',
                  fontSize: 14,
                  fontWeight: 700,
                  letterSpacing: '0.10000000149011612px',
                  textAlign: 'left',
                }}
              >
                Atualizar novamente
              </NewUiKitButton>
              <p>
                <strong>Última atualização: </strong>
                {user.last_input_update &&
                  formatCompleteDate(new Date(user.last_input_update))}
              </p>
            </div>
          </Col>
          <Col>
            <div style={{ marginTop: 20, float: 'right' }}>
              {activeTab === 1 && (
                <SearchDiv>
                  <Form>
                    <NewInput
                      containerStyles={{
                        borderRadius: 4,
                        height: '38px',
                        width: '210px',
                        backgroundColor: '#ffffff',
                      }}
                      style={{
                        width: '210px',
                      }}
                      placeholder="Pesquise por aqui"
                      type="text"
                      value={filterStringInter}
                      iconLeft={<IconSearch />}
                      iconRight={
                        <IconClose onClick={() => setFilterStringInter('')} />
                      }
                      onChange={(e) => {
                        setFilterStringInter(e.target.value);
                      }}
                    />
                  </Form>
                  <NewUiKitButton
                    onClick={() => {
                      activeTab === 0 ? toggle() : toggleIntermediary();
                    }}
                    style={{ float: 'right', borderRadius: 12 }}
                    icon={<IconPlus />}
                    customColor="#C8131B"
                  >
                    Adicionar
                  </NewUiKitButton>
                </SearchDiv>
              )}

              {(activeTab === 2 || activeTab === 3 || activeTab === 4) && (
                <div
                  style={{
                    height: 38,
                    width: 200,
                    paddingBottom: 5,
                    background: 'transparent',
                  }}
                />
              )}
            </div>
          </Col>
          {activeTab === 0 && (
            <>
              <Form
                onSubmit={clearInputFilters}
                style={{
                  display: 'flex',
                  paddingTop: 16,
                  alignItems: 'flex-start',
                  justifyContent: 'space-between',
                }}
              >
                <SearchDiv>
                  <NewInput
                    containerStyles={{
                      borderRadius: 8,
                      height: '38px',
                      backgroundColor: '#ffffff',
                    }}
                    name="filter"
                    placeholder="Pesquise por aqui"
                    isClearable
                    iconLeft={<IconSearch />}
                    iconRight={
                      <IconClose onClick={() => setFilterString('')} />
                    }
                    onChange={(e) => {
                      setFilterString(e.target.value);
                    }}
                    value={filterString}
                    color="#7A7A7A"
                  />
                  <NewSelect
                    options={categories}
                    onChange={(item) => {
                      setCashFlowCategoryInputs(item);
                    }}
                    value={cashFlowCategoryInputs}
                    containerStyles={{ borderRadius: 8 }}
                    controlStyles={{ border: '1px solid #7A7A7A' }}
                  />
                  <NewUiKitButton customColor="#2EC9B7">
                    {' '}
                    Limpar{' '}
                  </NewUiKitButton>
                </SearchDiv>
                {user.use_stock && [0, 1].includes(activeTab) && (
                  <NewUiKitButton
                    onClick={() => {
                      activeTab === 0 ? toggle() : toggleIntermediary();
                    }}
                    style={{ float: 'right', borderRadius: 12 }}
                    icon={<FaPlus style={{ fontSize: 14 }} />}
                    customColor="#C8131B"
                  >
                    Adicionar
                  </NewUiKitButton>
                )}
              </Form>
            </>
          )}
        </Row>
      )}

      {user.use_stock ? (
        <>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Tabs
              tabs={
                [2, 13].includes(user.id)
                  ? [
                      'Insumos',
                      'Produtos intermediários',
                      'Perdas',
                      'Sobras',
                      'Compras',
                      'Inventário por dia',
                      'Cotação Inteligente',
                    ]
                  : [
                      'Insumos',
                      'Produtos intermediários',
                      'Perdas',
                      'Sobras',
                      'Compras',
                      'Inventário por dia',
                    ]
              }
              onChangeTab={setActiveTab}
              selected={activeTab}
              mediaQueries={[
                {
                  maxWidth: 1140,
                  styles: `padding: 5px 15px;`,
                },
                {
                  maxWidth: 1095,
                  styles: `padding: 5px 10px;`,
                },
                {
                  maxWidth: 1050,
                  styles: `padding: 5px 10px;
                    font-size: 12px;
                  `,
                },
              ]}
            />

            {(activeTab === 2 || activeTab === 3) && (
              <div
                style={{
                  height: 38,
                  width: 200,
                  paddingBottom: 5,
                  background: 'transparent',
                }}
              />
            )}
          </div>

          <TabContent activeTab={activeTab}>
            <TabPane tabId={0}>
              <ComplementsTable borderless style={{ borderTopLeftRadius: 0 }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    paddingTop: 40,
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 20,
                    }}
                  >
                    <InventaryButton onClick={() => handleInventory()}>
                      {isInventory
                        ? 'Salvar inventário'
                        : '+ Realizar inventário'}
                    </InventaryButton>
                    <label>
                      <Form>
                        <CheckboxInput
                          name="filter_input_master"
                          label="Filtrar somente itens com controle individual"
                          onChange={() => {
                            setFilterInputMaster(!filterInputMaster);
                          }}
                          value={filterInputMaster}
                          spanStyle={{
                            marginLeft: 10,
                            marginBottom: 0,
                            fontWeight: 400,
                          }}
                        />
                      </Form>
                    </label>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 10,
                    }}
                  >
                    <DownloadButton onClick={() => handleDownloadInputs()} />
                    <span>
                      <strong>Insumo total em estoque:</strong> R${' '}
                      {inputsFiltered &&
                        inputsFiltered
                          .reduce((accum, curr) => {
                            return (
                              accum +
                              Number(
                                isNaN(curr.total_value) || curr.total_value < 0
                                  ? 0
                                  : curr.total_value
                              )
                            );
                          }, 0)
                          .toLocaleString('pt-BR', {
                            minimumFractionDigits: 2,
                          })}
                    </span>
                  </div>
                </div>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    paddingTop: 10,
                  }}
                >
                  {/* <FaQuestionCircle
                    color="orange"
                    title="Se houver controle de quantidade do produto, será criado um insumo vinculado a ele, e qualquer alteração no produto é refletida no insumo associado."
                    size={15}
                    style={{ marginLeft: 5, marginTop: 9 }}
                  /> */}
                </div>

                <StyledTable borderless>
                  <thead>
                    <tr>
                      <th>Insumo</th>
                      <th>Qtd em estoque</th>
                      <th>Custo UN</th>
                      <th>$ em estoque</th>
                      <th>Centro de custo</th>
                      {user?.regime_tributario === '2' && (
                        <>
                          <th>CFOP</th>
                          <th>CST ICMS</th>
                        </>
                      )}

                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {visibleInputs.map((input) => (
                      <InputRow
                        key={input.id}
                        input={input}
                        setInputs={setInputs}
                        handleDelete={handleDelete}
                        categories={categories}
                        filterString={filterString}
                        banks={banks}
                        suppliers={suppliers}
                        getBanks={getBanks}
                        getSuppliers={getSuppliers}
                        isInventory={isInventory}
                        inventory={inventory}
                        setInventory={setInventory}
                        getInputs={getInputs}
                        inputsFiltered={inputsFiltered}
                        setInputsFiltered={setInputsFiltered}
                        paymentMethods={paymentMethods}
                        user={user}
                      />
                    ))}

                    {visibleInputs.length < inputsFiltered.length && (
                      <div
                        ref={ref}
                        style={{ textAlign: 'center', padding: '20px' }}
                      >
                        Carregando mais insumos...
                      </div>
                    )}
                  </tbody>
                </StyledTable>
              </ComplementsTable>
            </TabPane>

            <TabPane tabId={1}>
              <ComplementsTable borderless>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    paddingTop: 10,
                  }}
                >
                  <InventaryButton
                    onClick={(e) => {
                      e.preventDefault();
                      handleInterInventory();
                    }}
                  >
                    {isInterInventory
                      ? 'Salvar inventário'
                      : '+ Realizar inventário'}
                  </InventaryButton>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 10,
                    }}
                  >
                    <DownloadButton
                      onClick={() => handleDownloadInters(intermediaryFiltered)}
                    />
                    <span>
                      <strong>Prod. interm. total em estoque:</strong> R${' '}
                      {intermediaryFiltered &&
                        intermediaryFiltered
                          .reduce((accum, curr) => {
                            return (
                              accum +
                              Number(
                                isNaN(curr.total_value) || curr.total_value < 0
                                  ? 0
                                  : curr.total_value
                              )
                            );
                          }, 0)
                          .toLocaleString('pt-BR', {
                            minimumFractionDigits: 2,
                          })}
                    </span>
                  </div>
                </div>

                <StyledTable borderless>
                  <thead>
                    <tr>
                      <th>Produto Intermediário</th>
                      <th>Quantidade em Estoque</th>
                      <th>Custo Unitário</th>
                      <th>Valor em Estoque</th>
                      <th>Quantidade Insumos</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {intermediaryFiltered.map((inter) => (
                      <IntermediaryRow
                        key={inter.id}
                        intermediary={inter}
                        setIntermediary={setIntermediary}
                        setIntermediaryFiltered={setIntermediaryFiltered}
                        handleDelete={handleDeleteIntermediary}
                        inputs={inputs}
                        intermediaries={intermediary}
                        getInputs={getInputs}
                        filterStringInter={filterStringInter}
                        filterString={filterString}
                        interInventory={interInventory}
                        isInterInventory={isInterInventory}
                        setInterInventory={setInterInventory}
                      />
                    ))}
                  </tbody>
                </StyledTable>
              </ComplementsTable>

              <Modal
                isOpen={isModalCreateSuppliersOpen}
                toggle={toggleModalCreateSuplliers}
              >
                <ModalHeader> Criar Fornecedor</ModalHeader>
                <Form onSubmit={handleSupplierSubmit} ref={formRefSupplier}>
                  <ModalBody>
                    <Input label="Nome do fornecedor" name="name" />
                    <Input label="CNPJ" name="cnpj" />
                    <ReactInputMask mask="(99) 99999-9999">
                      <Input
                        label="Telefone"
                        name="phone"
                        maskChar=""
                        placeholder="(xx) xxxxx-xxxx"
                      />
                    </ReactInputMask>
                  </ModalBody>
                  <ModalFooter>
                    <Button color="danger" onClick={toggleModalCreateSuplliers}>
                      Cancelar
                    </Button>
                    <Button color="success" type="submit">
                      Salvar
                    </Button>
                  </ModalFooter>
                </Form>
              </Modal>

              <Modal
                isOpen={isModalCreateBankOpen}
                toggle={toggleModalCreateBank}
              >
                <ModalHeader> Criar Conta</ModalHeader>
                <Form onSubmit={handleBankSubmit} ref={formRefBank}>
                  <ModalBody>
                    <Input label="Nome do banco" name="name" />
                  </ModalBody>
                  <ModalFooter>
                    <Button color="danger" onClick={toggleModalCreateBank}>
                      Cancelar
                    </Button>
                    <Button color="success" type="submit">
                      Salvar
                    </Button>
                  </ModalFooter>
                </Form>
              </Modal>

              <Modal isOpen={modalErroNotAllowed} toggle={toggle}>
         
                  <ModalHeader>
                    Contate a franqueadora para criar{' '}
                    {activeTab === 0 ? 'insumos' : 'produtos intermediários'}.
                  </ModalHeader>
                  <ModalFooter style={{ float: 'right' }}>
                    <Button
                      color="success"
                      type="submit"
                      onClick={() => activeTab === 0 ? toggle() : toggleIntermediary()}
                    >
                      Ok
                    </Button>
                  </ModalFooter>
            
              </Modal>

              <Modal
                isOpen={confirmModalClose}
                toggle={toggleConfirmModalClose}
              >
                <ModalHeader>
                  <h3 style={{ fontSize: 18 }}>
                    Seus dados preenchidos serão perdidos ao fechar o modal.
                  </h3>
                </ModalHeader>

                <ModalFooter>
                  <NewUiKitButton onClick={() => setConfirmModalClose(false)}>
                    Não fechar
                  </NewUiKitButton>
                  <NewUiKitButton
                    onClick={() => {
                      setModal(false);
                      setConfirmModalClose(false);
                    }}
                    customColor="#2EC9B7"
                  >
                    Fechar mesmo assim
                  </NewUiKitButton>
                </ModalFooter>
              </Modal>

              <ModalStyled
                isOpen={modal}
                toggle={toggle}
                size="lg"
                onClosed={() => {
                  setCreateCashFlowOnNewInput(true);
                  setInputsToAdd([]);
                }}
              >
                <ModalHeader>
                  <h3
                    style={{
                      fontWeight: 600,
                      fontSize: 18,
                      marginBottom: 8,
                    }}
                  >
                    Adicionar Insumos{' '}
                  </h3>
                  <NotificationBanner
                    variant="info"
                    isOpen
                    style={{ width: 756 }}
                  >
                    Novidade: Você pode dar entrada em vários insumos ao mesmo
                    tempo!
                  </NotificationBanner>
                </ModalHeader>
                <ModalBody>
                  <div style={{ display: 'flex', gap: 20 }}>
                    <span
                      style={{
                        fontWeight: 600,
                        fontSize: 16,
                      }}
                    >
                      Defina um tipo de insumo
                    </span>
                    <Radio
                      label="Novo Insumo"
                      onClick={() => handleChangeCreateType('new')}
                      checked={createType === 'new' && user.allow_inputs}
                      disabled={!user.allow_inputs}
                    />
                    <Radio
                      label="Insumo Existente"
                      onClick={() => handleChangeCreateType('edit')}
                      checked={createType === 'edit' || !user.allow_inputs}
                    />
                  </div>
                  {createType === 'new' && user.allow_inputs ? (
                    <InputInfoArea>
                      <InputLine>
                        <NewInput
                          label="Nome do Insumo:"
                          name="name"
                          value={inputToAdd.name}
                          onChange={(e) => handleChangeInputToAdd('name', e)}
                          style={{
                            width: 362,
                          }}
                        />

                        <NewInput
                          label="Estoque atual:"
                          name="quantidade"
                          type="number"
                          style={{
                            width: 362,
                          }}
                          value={inputToAdd.quantidade}
                          onChange={(e) =>
                            handleChangeInputToAdd('quantidade', e)
                          }
                        />
                      </InputLine>

                      <InputLine>
                        <NewSelect
                          label="Unidade:"
                          name="unidade"
                          options={unidade_options}
                          defaultValue={unidadeOptionsDefault}
                          value={unidadeOptionsDefault}
                          style={{
                            width: 176,
                          }}
                          onChange={(e) => {
                            handleChangeInputToAdd('unidade', e)
                            setUnidadeOptionsDefault(e)
                          }}
                        />

                        <NewInput
                          label="Valor Gasto"
                          name="total"
                          value={inputToAdd.total}
                          isCurrency
                          hasPrefix
                          defaultValue={1}
                          onChange={(e) => handleChangeInputToAdd('total', e)}
                          style={{
                            width: 176,
                          }}
                          icon={
                            <FaQuestionCircle
                              title="Custo referente à quantidade de insumo adicionado."
                              color="orange"
                              style={{ marginLeft: 5 }}
                            />
                          }
                        />

                        <NewInput
                          label="Estoque Mínimo"
                          name="minimum_stock"
                          value={inputToAdd.minimum_stock}
                          type="number"
                          onChange={(e) =>
                            handleChangeInputToAdd('minimum_stock', e)
                          }
                          icon={
                            <FaQuestionCircle
                              title="Caso o estoque do Insumo esteja abaixo da quantidade mínima, você receberá uma notificação na central de tarefas."
                              color="orange"
                              style={{ marginLeft: 5 }}
                            />
                          }
                          style={{
                            width: 176,
                          }}
                        />

                        <NewInput
                          label="Estoque Ideal"
                          name="ideal_stock"
                          onChange={(e) =>
                            handleChangeInputToAdd('ideal_stock', e)
                          }
                          value={inputToAdd.ideal_stock}
                          type="number"
                          style={{
                            width: 176,
                          }}
                        />
                      </InputLine>
                      <Row>
                        <Col>
                          <NewSelect
                            label="Associar centro de custo"
                            name="cash_flow_category_subcategory_id"
                            value={inputToAdd.cash_flow_category_subcategory}
                            options={categories}
                            placeholder="Selecione a categoria"
                            onChange={(e) =>
                              handleChangeInputToAdd(
                                'cash_flow_category_subcategory',
                                e
                              )
                            }
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                          />
                        </Col>
                      </Row>
                      <NewUiKitButton
                        icon={<IconPlus />}
                        customColor="#2EC9B7"
                        style={{ alignSelf: 'flex-end' }}
                        onClick={() => handleAddNewInput()}
                      >
                        Adicionar Insumo{' '}
                      </NewUiKitButton>
                    </InputInfoArea>
                  ) : (
                    <InputInfoArea>
                      <NewSelect
                        label="Selecione o Insumo"
                        options={inputs_select}
                        onChange={(e) => handleSelectInput(e)}
                      />
                      <InputLine>
                        <InfoDiv>
                          <p>Qtd. Disponível</p>
                          <span>
                            {inputToAdd?.quantidade
                              ? parseFloat(inputToAdd?.quantidade).toFixed(4)
                              : '-'}
                          </span>
                        </InfoDiv>
                        <InfoDiv>
                          <p>Custo Unitário Atual</p>
                          <span>R$ {inputToAdd.unitary_price || '-'}</span>
                        </InfoDiv>
                        <InfoDiv>
                          <p>Valor em estoque</p>
                          <span>{inputToAdd.total_value || '-'}</span>
                        </InfoDiv>
                      </InputLine>
                      <InputLine>
                        <span
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                          }}
                        >
                          <span
                            style={{
                              color: '#545454',
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Quantidade
                          </span>
                          <span
                            style={{
                              display: 'flex',
                              width: 238,
                              gap: 4,
                            }}
                          >
                            <NewUiKitButton
                              style={{
                                borderRadius: '50%',
                              }}
                              icon={<IconMinus />}
                              onClick={() => {
                                setInputQuant(parseFloat(inputQuant) - 1);
                                setInputZero(parseFloat(inputZero) - 1);
                                setValueToSend(
                                  Number(inputInicial) +
                                    parseFloat(inputZero) -
                                    1
                                );
                              }}
                              disabled={inputZero <= 0}
                            />
                            <NewInput
                              type="number"
                              value={inputZero}
                              onChange={(e) => {
                                setInputZero(e.target.value);
                                setValueToSend(
                                  Number(inputInicial) +
                                    parseFloat(e.target.value)
                                );
                              }}
                            />
                            <NewUiKitButton
                              style={{
                                borderRadius: '50%',
                              }}
                              icon={<IconPlus />}
                              customColor="#2EC9B7"
                              onClick={() => {
                                setInputQuant(parseFloat(inputQuant) + 1);
                                setInputZero(parseFloat(inputZero) + 1);
                                setValueToSend(
                                  Number(inputInicial) +
                                    parseFloat(inputZero) +
                                    1
                                );
                              }}
                            />
                          </span>
                        </span>
                        <NewInput
                          label="Valor Gasto"
                          value={totalToSend}
                          onChange={(e) => setTotalToSend(e.target.value)}
                          name="total_to_send"
                          type="number"
                          style={{
                            display: 'flex',
                            flex: '1 0 0',
                          }}
                        />
                        <NewInput
                          label="Nova Qtd."
                          name="yield"
                          value={
                            isNaN(Number(inputInicial) + Number(inputZero))
                              ? Number(inputInicial).toFixed(4)
                              : (
                                  Number(inputInicial) + Number(inputZero)
                                ).toFixed(4)
                          }
                          style={{
                            display: 'flex',
                            flex: '1 0 0',
                          }}
                        />
                      </InputLine>
                      {Number(inputInicial) + parseFloat(inputZero) > 0 &&
                        parseFloat(inputZero) >= 0 && (
                          <InputLine
                            style={{
                              flexDirection: 'column',
                              alignItems: 'start',
                              marginTop: 8,
                            }}
                          >
                            <span
                              style={{
                                color: '#545454',
                                fontWeight: 600,
                                fontSize: 16,
                                lineHeight: '24px',
                              }}
                            >
                              Qual custo unitário usar?
                            </span>
                            <span style={{ display: 'flex', gap: 20 }}>
                              <Radio
                                onClick={() => {
                                  handleChangeAverage();
                                }}
                                checked={isAverage}
                                label={`Novo (R$ ${(inputZero === 0 ||
                                isNaN(
                                  parseFloat(totalToSend) /
                                    parseFloat(inputZero)
                                )
                                  ? 0
                                  : parseFloat(totalToSend) /
                                    parseFloat(inputZero)
                                ).toFixed(2)})`}
                              />
                              <Radio
                                onClick={() => {
                                  handleChangeAverage();
                                }}
                                checked={!isAverage}
                                label={`Média Ponderada (R$ ${(
                                  0 +
                                  (parseFloat(totalToSend) +
                                    parseFloat(inputToAdd.total_value)) /
                                    (parseFloat(inputZero) +
                                      parseFloat(inputToAdd.quantidade))
                                ).toFixed(2)})`}
                              />
                            </span>
                          </InputLine>
                        )}

                      <InputLine>
                        <NewInput
                          label="Estoque Ideal"
                          style={{
                            width: 238,
                          }}
                          value={inputToAdd.ideal_stock}
                          onChange={(e) =>
                            handleChangeInputToAdd('ideal_stock', e)
                          }
                        />
                        <NewInput
                          label="Estoque Mínimo"
                          style={{
                            width: 238,
                          }}
                          value={inputToAdd.minimum_stock}
                          onChange={(e) =>
                            handleChangeInputToAdd('minimum_stock', e)
                          }
                        />
                        <NewSelect
                          label="Centro de Custo"
                          containerStyles={{
                            width: 238,
                          }}
                          options={categories}
                          value={inputToAdd.cash_flow_category_subcategory}
                          onChange={(e) =>
                            handleChangeInputToAdd(
                              'cash_flow_category_subcategory',
                              e
                            )
                          }
                          isDisabled={(!user.allow_inputs && inputToAdd?.is_multistore_child) || false}
                        />
                      </InputLine>
                      <NewUiKitButton
                        icon={<IconPlus />}
                        customColor="#2EC9B7"
                        style={{ alignSelf: 'flex-end' }}
                        onClick={() => handleAddNewInput()}
                      >
                        Adicionar Insumo{' '}
                      </NewUiKitButton>
                    </InputInfoArea>
                  )}

                  <TableArea>
                    <TableStyled>
                      <table>
                        <thead>
                          <tr>
                            <th style={{ width: 194, textAlign: 'left' }}>
                              Insumo
                            </th>
                            <th>UN</th>
                            <th>Estoque Atual</th>
                            <th>Valor Gasto</th>
                            <th>Estoque Min.</th>
                            <th>Estoque Ideal </th>
                            <th style={{ width: 147 }}>Centro de Custo</th>
                            <th />
                          </tr>
                        </thead>
                        <tbody>
                          {inputsToAdd &&
                            inputsToAdd.length > 0 &&
                            inputsToAdd.map((input) => (
                              <tr>
                                <td style={{ width: 194, textAlign: 'left' }}>
                                  {input.name}
                                </td>
                                <td>{input.unidade}</td>
                                <td>{input.quantidade}</td>
                                <td>R$ {input.total}</td>
                                <td>{input.minimum_stock}</td>
                                <td>{input.ideal_stock}</td>
                                <td style={{ width: 147 }}>
                                  {input.cash_flow_category_subcategory.label}
                                </td>
                                <td>
                                  <IconTrashFilled
                                    fill="#C8131B"
                                    fontSize={16}
                                    style={{
                                      cursor: 'pointer',
                                    }}
                                    onClick={() =>
                                      handleDeleteInputAtList(input.id)
                                    }
                                  />
                                </td>
                              </tr>
                            ))}
                          <tr />
                        </tbody>
                        {totalInputs > 0 && (
                          <tfoot>
                            <tr>
                              <td
                                style={{
                                  color: '#222',
                                  textAlign: 'left',
                                  background: '#ededed',
                                  fontWeight: 600,
                                  padding: '10px',
                                }}
                                colSpan={3}
                              >
                                Total valor gasto:
                              </td>
                              <td
                                style={{
                                  color: '#222',
                                  paddingLeft: 8,
                                  background: '#ededed',
                                  fontWeight: 600,
                                }}
                              >
                                {totalInputs > 0 && formatPrice(totalInputs)}
                              </td>
                              <td
                                colSpan={3}
                                style={{ background: '#ededed' }}
                              />
                            </tr>
                          </tfoot>
                        )}
                      </table>
                    </TableStyled>
                  </TableArea>

                  <Checkbox
                    name="create_cashflow"
                    label="Vincular esta movimentação ao financeiro"
                    onChange={() => {
                      handleCreateCashFlowOnNewInput();
                    }}
                    containerStyles={{ marginTop: 8 }}
                    checked={createCashFlowOnNewInput}
                  />

                  <div
                    style={{
                      display: 'flex',
                      marginTop: 8,
                      alignItems: 'center',
                    }}
                  >
                    <FaExclamationTriangle color="#FFB32F" />{' '}
                    <span
                      style={{
                        marginLeft: 6,
                        fontSize: 12,
                        fontWeight: 500,
                      }}
                    >
                      Entrada de insumos unificada gera lançamento financeiro
                      único.
                    </span>
                  </div>

                  {createCashFlowOnNewInput && (
                    <>
                      <InputLine>
                        <InputLine>
                          <NewSelect
                            label="Fornecedor"
                            name="provider_id"
                            options={suppliers}
                            placeholder="Fornecedor"
                            containerStyles={{ width: 324 }}
                            onChange={(e) => setProviderId(e.value)}

                            // onChange={(e) => setInputSelectedId(e.value)}
                          />

                          <NewUiKitButton
                            type="button"
                            style={{
                              width: 40,
                              height: 40,
                              background: '#2EC9B7',
                              marginTop: 28,
                            }}
                            title="Cadastrar Fornecedor"
                            onClick={toggleModalCreateSuplliers}
                            icon={<IconPlus />}
                          />
                        </InputLine>
                        <InputLine>
                          <NewSelect
                            label="Conta"
                            name="bank_account_id"
                            options={banks}
                            placeholder="Conta"
                            containerStyles={{ width: 324 }}
                            onChange={(e) => setBankId(e.value)}
                          />

                          <NewUiKitButton
                            type="button"
                            style={{
                              width: 40,
                              height: 40,
                              background: '#2EC9B7',
                              marginTop: 28,
                            }}
                            onClick={toggleModalCreateBank}
                            icon={<IconPlus />}
                            title="Cadastrar Conta Bancária"
                          />
                        </InputLine>
                      </InputLine>
                      <InputLine style={{ marginTop: 8 }}>
                        <NewSelect
                          placeholder="Método de pagamento"
                          options={paymentMethods}
                          name="cash_flow_payment_method_id"
                          containerStyles={{
                            width: 372,
                          }}
                          label="Método de pagamento"
                          onChange={(e) => setCashFlowPaymentMethodId(e.value)}
                        />

                        <span
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                          }}
                        >
                          <span
                            style={{
                              fontWeight: 600,
                              fontSize: 16,
                              color: '#545454',
                            }}
                          />
                          <SingleCalendar
                            label="Vencimento"
                            type="date"
                            name="due_date"
                            defaultValue={format(new Date(), 'yyyy-MM-dd')}
                            onlyDate
                            containerStyles={{
                              width: 366,
                            }}
                            style={{
                              justifyContent: 'space-between',
                            }}
                            onSelectDate={(e) => setDueDate(e)}
                          />
                        </span>
                      </InputLine>
                      <div style={{ marginTop: 8 }}>
                        <Checkbox
                          name="paid"
                          label="Pago"
                          checked={paidCheck}
                          onChange={(e) => handleSetPaidCheck(e.target.value)}
                        />
                      </div>

                      {paidCheck && (
                        <SingleCalendar
                          onlyDate
                          label="Pago em"
                          type="date"
                          name="paid_at"
                          defaultValue={format(new Date(), 'yyyy-MM-dd')}
                          containerStyles={{
                            width: 328,
                          }}
                          style={{
                            justifyContent: 'space-between',
                          }}
                          onSelectDate={(e) => setPaidDate(e)}
                        />
                      )}
                    </>
                  )}
                </ModalBody>

                <FooterModal
                  style={{
                    padding: 12,
                    paddingRight: 6,
                  }}
                >
                  <Divider style={{ marginBottom: 12 }} />
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <NewUiKitButton onClick={() => setModal(false)}>
                      Cancelar
                    </NewUiKitButton>
                    <NewUiKitButton
                      onClick={handleSubmitInputs}
                      disabled={isSubmittingInput}
                      customColor="#2EC9B7"
                    >
                      Salvar Insumo(s)
                    </NewUiKitButton>
                  </div>
                </FooterModal>
              </ModalStyled>

              <Modal
                isOpen={modalIntermediary}
                toggle={toggleIntermediary}
                size="xl"
              >
                <Form onSubmit={handleIntermediary} ref={formIntermediaryRef}>
                  <ModalHeader>Adicionar Produto Intermediário</ModalHeader>
                  <ModalBody>
                    <Container>
                      <Row>
                        <Col md="12">
                          <Input
                            label="Nome:"
                            name="name"
                            id="name_intermediary"
                            type="text"
                            onChange={(e) =>
                              setNameIntermediary(e.target.value)
                            }
                          />
                        </Col>
                      </Row>
                      {/* <Row>
                        <Col md="12">
                          <p>
                            O rendimento da ficha técnica (receita) que iremos
                            inserir, produz:
                          </p>
                        </Col>
                      </Row> */}
                      <Row>
                        <Col md="7">
                          <Input
                            name="yield"
                            label="Rendimento da ficha técnica (receita) produz:"
                            defaultValue={1}
                            type="number"
                            step="0.001"
                            onChange={(e) =>
                              setYeldIntermediary(e.target.value)
                            }
                          />
                        </Col>
                        {/* <Col md="3">
                          <p style={{ marginTop: 15 }}>
                            {unidadeSelected} de{' '}
                            {nameIntermediary === '' ? '-' : nameIntermediary}
                          </p>
                        </Col> */}
                        <Col md="5">
                          <Select
                            label="Unidade:"
                            name="unidade"
                            options={unidade_options}
                            defaultValue={unidadeOptionsDefault}
                            value={unidadeOptionsDefault}
                            onChange={(e) => {
                              handleChangeInputToAdd('unidade', e)
                              setUnidadeOptionsDefault(e)
                            }}
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{
                          marginTop: 10,
                          marginBottom: 10,
                        }}
                      >
                        <Col md="12" style={{ marginTop: 10 }}>
                          <p>Ficha Técnica</p>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <Select
                            label="Insumos"
                            name="inputs_select"
                            options={inputs_select}
                            placeholder="Selecione"
                            onChange={(e) => setSelectInput(e)}
                            icon={
                              <FaQuestionCircle
                                title="Vincule os insumos usados na receita para produzir seu produto intermediário"
                                color="orange"
                                style={{ marginLeft: 5 }}
                              />
                            }
                          />
                        </Col>
                        <Col md="4">
                          <Input
                            label="Quantidade"
                            name="quantidade"
                            type="text"
                            defaultValue={0}
                            onChange={(e) => {
                              setDefaultInterValue(e.target.value);
                              document.getElementById('add').disabled = false;
                            }}
                            icon={
                              <FaQuestionCircle
                                title="Insira a quantidade necessária utilizada na receita para produzir seu produto intermediário."
                                color="orange"
                                style={{ marginLeft: 5 }}
                              />
                            }
                          />
                        </Col>
                        <Col
                          md="2"
                          style={{ margin: 'auto', marginBottom: 15 }}
                        >
                          <button
                            type="button"
                            id="add"
                            style={{
                              background: '#3BD2C1',
                              width: 40,
                              height: 40,
                              borderRadius: '50%',
                              border: 'none',
                              fontSize: 16,
                            }}
                            onClick={() =>
                              insertInputInter(selectInput, defaultInterValue)
                            }
                          >
                            +
                          </button>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="12">
                          <InputsTable borderless>
                            <thead>
                              <tr>
                                <th>Insumo</th>
                                <th>
                                  Consumo unitário{' '}
                                  <FaQuestionCircle
                                    title="Quantidade necessária para
                            se produzir uma unidade do Produto Intermediário."
                                    color="orange"
                                    style={{ marginLeft: 2 }}
                                  />
                                </th>
                                <th>
                                  Custo do insumo{' '}
                                  <FaQuestionCircle
                                    title="Custo de uma unidade do insumo."
                                    color="orange"
                                    style={{ marginLeft: 2 }}
                                  />
                                </th>
                                <th>
                                  Consumo total{' '}
                                  <FaQuestionCircle
                                    title="Quantidade necessária para
                                se produzir uma receita do Produto Intermediário."
                                    color="orange"
                                    style={{ marginLeft: 2 }}
                                  />
                                </th>
                                <th>
                                  Custo da receita{' '}
                                  <FaQuestionCircle
                                    title="Custo para se produzir uma receita do Produto Intermediário."
                                    color="orange"
                                    style={{ marginLeft: 2 }}
                                  />
                                </th>
                                <th>Disponível</th>
                                <th>Ações</th>
                              </tr>
                            </thead>

                            <tbody>
                              {interInputs.length > 0 &&
                                interInputs.map((input) => (
                                  <tr>
                                    <td>{input.name}</td>
                                    <td>
                                      {parseFloat(
                                        input.quantidade_inter_value /
                                          yeldIntermediary
                                      ).toLocaleString('pt-BR', {
                                        minimumFractionDigits: 2,
                                      })}{' '}
                                      {input.unidade}
                                    </td>

                                    <td>
                                      R$
                                      {parseFloat(
                                        input.unitary_price
                                      ).toLocaleString('pt-BR', {
                                        minimumFractionDigits: 2,
                                      })}
                                    </td>
                                    <td>
                                      {parseFloat(input.quantidade_inter_value)
                                        .toFixed(4)
                                        .replace('.', ',')}{' '}
                                      {input.unidade}
                                    </td>

                                    <td>
                                      R$
                                      {parseFloat(
                                        input.quantidade_inter_value *
                                          // yeldIntermediary *
                                          input.unitary_price
                                      ).toLocaleString('pt-BR', {
                                        minimumFractionDigits: 2,
                                      })}
                                    </td>
                                    <td>
                                      {' '}
                                      {parseFloat(input.quantidade)
                                        .toFixed(4)
                                        .replace('.', ',')}{' '}
                                      {input.unidade}
                                    </td>

                                    <td>
                                      <Delete
                                        type="button"
                                        onClick={() =>
                                          deleteInputInter(input.id)
                                        }
                                      >
                                        <MdDelete size={20} />
                                      </Delete>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </InputsTable>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <div style={{ margin: 5 }} />
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <Select
                            label="Prod. Interm."
                            name="inter_select"
                            options={inter_select}
                            placeholder="Selecione"
                            onChange={(e) => setSelectInter(e)}
                            icon={
                              <FaQuestionCircle
                                title="Vincule os produtos intermediários usados na receita para produzir seu novo produto intermediário."
                                color="orange"
                                style={{ marginLeft: 5 }}
                              />
                            }
                          />
                        </Col>
                        <Col md="4">
                          <Input
                            label="Quantidade"
                            name="quantidade"
                            type="text"
                            defaultValue={0}
                            onChange={(e) => {
                              setDefaultInterInterValue(
                                e.target.value.replace(',', '.')
                              );
                              document.getElementById('add1').disabled = false;
                            }}
                          />
                        </Col>
                        <Col
                          md="2"
                          style={{ margin: 'auto', marginBottom: 15 }}
                        >
                          <button
                            type="button"
                            id="add1"
                            style={{
                              background: '#3BD2C1',
                              width: 40,
                              height: 40,
                              borderRadius: '50%',
                              border: 'none',
                              fontSize: 16,
                            }}
                            onClick={() =>
                              insertInterInter(
                                selectInter,
                                defaultInterInterValue
                              )
                            }
                          >
                            +
                          </button>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="12">
                          <InputsTable borderless>
                            <thead>
                              <tr>
                                <th>Prod. interm.</th>
                                <th>Consumo nitário</th>
                                <th>Custo do Prod. Int.</th>
                                <th>Consumo total</th>
                                <th>Custo da receita</th>
                                <th>Disponível</th>
                                <th>Ações</th>
                              </tr>
                            </thead>

                            <tbody>
                              {interInter.length > 0 &&
                                interInter.map((inter) => (
                                  <tr>
                                    <td>{inter.name}</td>
                                    <td>
                                      {parseFloat(
                                        inter.quantidade_inter_value /
                                          yeldIntermediary
                                      ).toLocaleString('pt-BR', {
                                        minimumFractionDigits: 2,
                                      })}{' '}
                                      {inter.unidade}
                                    </td>

                                    <td>
                                      R$
                                      {parseFloat(
                                        inter.unitary_price
                                      ).toLocaleString('pt-BR', {
                                        minimumFractionDigits: 2,
                                      })}
                                    </td>
                                    <td>
                                      {parseFloat(inter.quantidade_inter_value)
                                        .toFixed(3)
                                        .replace('.', ',')}
                                      {inter.unidade}
                                    </td>

                                    <td>
                                      R$
                                      {parseFloat(
                                        inter.quantidade_inter_value *
                                          // yeldIntermediary *
                                          inter.unitary_price
                                      ).toLocaleString('pt-BR', {
                                        minimumFractionDigits: 2,
                                      })}
                                    </td>
                                    <td>
                                      <td>
                                        {' '}
                                        {parseFloat(inter.quantidade)
                                          .toFixed(4)
                                          .replace('.', ',')}{' '}
                                        {inter.unidade}
                                      </td>
                                    </td>

                                    <td>
                                      <Delete
                                        type="button"
                                        onClick={() =>
                                          deleteInterInter(inter.id)
                                        }
                                      >
                                        <MdDelete size={20} />
                                      </Delete>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </InputsTable>
                        </Col>
                      </Row>

                      <Row style={{ marginTop: 10 }}>
                        <Col style={{ marginTop: 10 }}>
                          <p>Receita</p>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="12">
                          <TextareaContainer
                            name="recipe"
                            placeholder="Salve a receita do produto intermediário"
                            type="text"
                            maxLength="500"
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md="12">
                          <Input
                            label="Quantidade em Estoque"
                            name="quantidade_inter"
                            onChange={(e) => setQuantInter(e.target.value)}
                            type="number"
                            step="0.001"
                            icon={
                              <FaQuestionCircle
                                title="Quantidade criada do Produto Intermediário nessa receita."
                                color="orange"
                                style={{ marginLeft: 5 }}
                              />
                            }
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <Input
                            label="Estoque Mínimo"
                            name="minimum_stock"
                            icon={
                              <FaQuestionCircle
                                title="Caso o estoque do Produto Intermediário esteja abaixo da quantidade mínima, você receberá uma notificação na central de tarefas.."
                                color="orange"
                                style={{ marginLeft: 5 }}
                              />
                            }
                          />
                        </Col>
                        <Col md="6">
                          <Input label="Estoque Ideal" name="ideal_stock" />
                        </Col>
                      </Row>
                      <Row>
                        <Col md="8">
                          <CheckboxInput
                            name="discount_inputs"
                            label="Ao criar a ficha técnica, descontar insumos e produtos intermediários do estoque"
                            onChange={() => {
                              setDiscountInputsOnHandleInter(
                                !discountInputsOnHandleInter
                              );
                            }}
                            value={discountInputsOnHandleInter}
                            checked={discountInputsOnHandleInter}
                            spanStyle={{
                              marginLeft: 10,
                              fontWeight: 400,
                              marginTop: 7,
                            }}
                          />
                        </Col>
                      </Row>
                    </Container>
                  </ModalBody>
                  <ModalFooter>
                    <NewUiKitButton onClick={toggleIntermediary}>
                      Cancelar
                    </NewUiKitButton>
                    <NewUiKitButton
                      type="submit"
                      disabled={isSubmittingIntermediary}
                      customColor="#3bd2c1"
                    >
                      Salvar
                    </NewUiKitButton>
                  </ModalFooter>
                </Form>
              </Modal>
            </TabPane>

            <TabPane tabId={2}>
              {activeTab === 2 ? <InputLossReport type="-" /> : <></>}
            </TabPane>

            <TabPane tabId={3}>
              {activeTab === 3 ? <InputLossReport type="+" /> : <></>}
            </TabPane>

            <TabPane tabId={4}>
              {activeTab === 4 ? <InputNfeReport /> : <></>}
            </TabPane>

            <TabPane tabId={5}>
              {activeTab === 5 ? <InputInventoryReport /> : <></>}
            </TabPane>

            <TabPane tabId={6}>
              {activeTab === 6 ? <InputSmartQuote /> : <></>}
            </TabPane>
          </TabContent>
        </>
      ) : (
        <ErrorContainer>
          <p style={{ fontSize: 23 }}>
            Boas notícias! Seu plano atual já contempla a função de controle de
            estoque!
          </p>
          <p style={{ fontSize: 16 }}>
            Para ativar essa funcionalidade, entre em contato com o time de
            suporte que sua ativação será realizada sem custos extras.
          </p>
        </ErrorContainer>
      )}
    </Container>
  );
}

export default Inputs;
